<template>
  <div class="fcw-root relative h-screen overflow-hidden bg-[#0a0a0c] text-white">
    <header v-if="uiMode === 'simple'" class="fcw-top-nav" aria-label="工作台导航">
      <button type="button" class="fcw-back-btn" aria-label="返回首页" title="返回首页" @click="onBack">
        <span class="fcw-back-btn__icon" aria-hidden="true">
          <i class="fas fa-chevron-left"></i>
        </span>
        <span class="fcw-back-btn__text">返回</span>
      </button>
    </header>

    <FreeCanvasSimpleWorkspace v-if="uiMode === 'simple'" />
    <NodeGraphCanvas v-else class="h-full" />
  </div>
</template>

<script>
import FreeCanvasSimpleWorkspace from './FreeCanvasSimpleWorkspace.vue'
import NodeGraphCanvas from './NodeGraphCanvas.vue'

const STORAGE_MODE = 'freeCanvasUiMode'

export default {
  name: 'FreeCanvasWorkspace',
  components: { FreeCanvasSimpleWorkspace, NodeGraphCanvas },
  data() {
    return {
      uiMode: 'node'
    }
  },
  watch: {
    '$route.query': {
      handler() {
        this.applyRouteMode()
      },
      deep: true
    }
  },
  created() {
    this.applyRouteMode()
    this.applyStoredModeFallback()
  },
  methods: {
    onBack() {
      this.$router.push('/').catch(() => {})
    },
    applyRouteMode() {
      const q = this.$route.query || {}
      const simple = q.simple === '1' || q.simple === 1 || q.simple === true
      if (simple) {
        this.uiMode = 'simple'
        try {
          localStorage.setItem(STORAGE_MODE, 'simple')
        } catch (e) {
          /* ignore */
        }
        return
      }
      if (q.simple === '0' || q.node === '1' || q.node === 1) {
        this.uiMode = 'node'
        try {
          localStorage.setItem(STORAGE_MODE, 'node')
        } catch (e) {
          /* ignore */
        }
      }
    },
    applyStoredModeFallback() {
      if (this.$route.query && (this.$route.query.simple != null || this.$route.query.node != null)) {
        return
      }
      try {
        const v = localStorage.getItem(STORAGE_MODE)
        if (v === 'simple' || v === 'node') this.uiMode = v
      } catch (e) {
        /* ignore */
      }
    }
  }
}
</script>

<style scoped>
/* 顶栏：与侧栏「新建项目 / 保存」同系深色面板风格 */
.fcw-top-nav {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  padding: 12px 14px;
  pointer-events: none;
}

.fcw-back-btn {
  pointer-events: auto;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 0 12px 0 10px;
  margin: 0;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.055);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: rgba(255, 255, 255, 0.92);
  cursor: pointer;
  transition:
    background 0.18s ease,
    border-color 0.18s ease,
    color 0.18s ease;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.fcw-back-btn__icon {
  display: inline-flex;
  width: 16px;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  opacity: 0.9;
}

.fcw-back-btn__text {
  line-height: 1;
}

.fcw-back-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.16);
  color: #fff;
}

.fcw-back-btn:active {
  background: rgba(255, 255, 255, 0.07);
  transform: scale(0.98);
}

/* 简易画布：侧栏较窄，保持浮层按钮不挤压文字 */
.fcw-root:has(.fc-workspace) .fcw-top-nav {
  padding: 12px 14px;
  background: linear-gradient(
    105deg,
    rgba(17, 17, 20, 0.88) 0%,
    rgba(17, 17, 20, 0.45) 55%,
    transparent 100%
  );
}
</style>
